import React, { useEffect } from 'react';
import { C } from './UI';
import { DonationCenterDto } from '../services/api';

interface Props {
    center: DonationCenterDto;
    onClose: () => void;
}

export function DonationCenterDetailsModal({ center, onClose }: Props) {
    useEffect(() => {
        const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [onClose]);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = ''; };
    }, []);

    return (
        <div
            onClick={onClose}
            style={{
                position: 'fixed', inset: 0, zIndex: 1000,
                background: 'rgba(0,0,0,0.75)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: 24,
                backdropFilter: 'blur(4px)',
            }}
        >
            <div
                onClick={e => e.stopPropagation()}
                style={{
                    background: '#fff',
                    borderRadius: 14,
                    overflow: 'hidden',
                    maxWidth: 420,
                    width: '100%',
                    boxShadow: '0 24px 80px rgba(0,0,0,0.35)',
                }}
            >
                <div style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
                    padding: '16px 18px',
                    borderBottom: `1px solid ${C.border}`,
                }}>
                    <div>
                        <div style={{ fontWeight: 700, fontSize: 16, color: C.text }}>{center.name}</div>
                        <div style={{ fontSize: 13, color: C.textSub, marginTop: 2 }}>{center.address}</div>
                        {center.phone && (
                            <div style={{ fontSize: 13, color: C.textSub, marginTop: 2 }}>{center.phone}</div>
                        )}
                    </div>
                    <button
                        onClick={onClose}
                        style={{
                            background: C.bg, border: 'none', borderRadius: '50%',
                            width: 32, height: 32, cursor: 'pointer', flexShrink: 0,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 16, color: C.textSub,
                        }}
                    >
                        ✕
                    </button>
                </div>

                <div style={{ padding: 18 }}>
                    {center.description ? (
                        <div style={{ fontSize: 14, color: C.text, lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
                            {center.description}
                        </div>
                    ) : (
                        <div style={{ fontSize: 14, color: C.textMuted }}>
                            No additional details for this center yet.
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
